export const BACKGROUNDS = [
  "linear-gradient(180deg, #A30A7C -0.29%, #D541A5 64.32%, #EB59B7 99.12%)",
  "linear-gradient(180deg, #64FFDD -0.29%, #A5D6D5 39.47%, #E2B0CE 80.23%, #FBA2CC 99.12%)",
  "linear-gradient(180deg, #2DCED9 -0.29%, #45CDC3 15.61%, #82CA8C 47.42%, #E5C635 95.14%, #EFC62D 99.12%)",
  "linear-gradient(180deg, #FF992E -0.29%, #F88038 21.58%, #E74352 66.31%, #DA1467 99.12%)",
  "linear-gradient(180deg, #31CCD9 -0.29%, #36C9D5 2.69%, #99A096 50.41%, #D6866E 83.21%, #EF7C5F 99.12%)",
  "linear-gradient(180deg, #7ED4EF -0.29%, #65BFE6 22.57%, #288AD0 70.29%, #0169C2 99.12%)",
  "linear-gradient(180deg, #6CC3F4 -0.29%, #7FAAE9 16.61%, #B26DCD 52.4%, #FA15A6 99.12%)",
  "var(--Color-4, #7E8AAD33)",
];
